const isFunction = (value: any) => typeof value === 'function';

const callFunction = (func: any, props: any) =>
  [func].filter(isFunction).map((func) => func(props));

export { isFunction, callFunction };
